import { STAFF_IMPORT_PAGE_COPY } from '../constants/staffImport';
import type { AnalyzeResult } from '../types/staffImport';

type DeriveProcessImportDisabledReasonInput = {
    processing: boolean;
    statusProcessing: boolean;
    analyzeResult: AnalyzeResult | null;
    isReadyForImport: boolean;
};

export const deriveProcessImportDisabledReason = ({
    processing,
    statusProcessing,
    analyzeResult,
    isReadyForImport,
}: DeriveProcessImportDisabledReasonInput): string | undefined => {
    if (isReadyForImport && !processing) {
        return undefined;
    }

    if (processing) {
        return STAFF_IMPORT_PAGE_COPY.processImportDisabledProcessing;
    }

    if (statusProcessing) {
        return STAFF_IMPORT_PAGE_COPY.processImportDisabledAnalyzing;
    }

    if (!analyzeResult) {
        return STAFF_IMPORT_PAGE_COPY.processImportDisabledAwaitImport;
    }

    if (!isReadyForImport) {
        return STAFF_IMPORT_PAGE_COPY.processImportDisabledValidation;
    }

    return undefined;
};
